import React from 'react';
import { Icon } from '../../index';

export const NavigationHeadIcon = ({
    className,
    color,
    disabled,
    icon,
}) => {

    const navHeaderIconClasses = [
        `bsw-navigation__header-icon`,
        `${disabled ? 'bsw-navigation__header-icon--disabled' : ''}`,
        `${className ? className : ''}`,
    ].join(' ');

    return (
        <div className={navHeaderIconClasses}>
            <Icon name={icon} color={color} size="small" disabled={disabled} />
        </div>
    );

}
